import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutlineRounded";
import SmartDisplayOutlinedIcon from "@mui/icons-material/SmartDisplayOutlined";
import { isVideoFile } from "@entrilia/shared/utilities/fileHelper";
import type { Message } from "../../../store/state/messages/types";
import { MessageType } from "../../../store/state/messages/types";

interface Props {
  message: Message;
}

export const MessageTypeComponent = (props: Props) => {
  const { message } = props;

  if (message.type === MessageType.Document) {
    const hasVideoAttachment =
      message.attachments?.some((attachment) => isVideoFile(attachment.fileName)) ||
      isVideoFile(message.content?.subject ?? "");

    if (hasVideoAttachment) {
      return <SmartDisplayOutlinedIcon color="secondary" />;
    }

    return <DescriptionOutlinedIcon color="secondary" />;
  } else {
    return <MailOutlineIcon color="secondary" />;
  }
};

export default MessageTypeComponent;
